import { render, staticRenderFns } from "./work_item_create_branch_merge_request_modal.vue?vue&type=template&id=653a2560"
import script from "./work_item_create_branch_merge_request_modal.vue?vue&type=script&lang=js"
export * from "./work_item_create_branch_merge_request_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports